import React from 'react';
import { Layout, Drawer } from 'antd';
import { useSidebarContext } from './SidebarContext';
import { useTheme } from '../../../contexts/ThemeContext';
import SidebarHeader from './SidebarHeader';
import SidebarSearch from './SidebarSearch';
import SidebarMenu from './SidebarMenu';
import SidebarFooter from './SidebarFooter';
import { getThemedStyles, SIDEBAR_WIDTH, SIDEBAR_COLLAPSED_WIDTH } from './styles';

const { Sider } = Layout;

/**
 * 侧边栏内容组件
 * 使用 flex 布局，菜单区域可滚动
 */
const SidebarContent = ({ isDark }) => {
  const themedStyles = getThemedStyles(isDark);
  
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      background: themedStyles.colors.bg,
    }}>
      <SidebarHeader />
      <SidebarSearch />
      <SidebarMenu />
      <SidebarFooter />
    </div>
  );
};

/**
 * 侧边栏组件
 * 根据设备类型渲染不同的布局
 * 注意：需要在 SidebarProvider 内部使用
 */
const Sidebar = () => {
  const { collapsed, isMobile, drawerVisible, closeDrawer } = useSidebarContext();
  const { isDark } = useTheme();
  const themedStyles = getThemedStyles(isDark);
  
  // Sider 基础样式（不包含 flex，因为内部容器处理）
  const siderBaseStyle = {
    position: 'fixed',
    left: 0,
    top: 0,
    bottom: 0,
    zIndex: 100,
    background: themedStyles.colors.bg,
    boxShadow: themedStyles.colors.shadow,
    overflow: 'hidden',
    transition: 'background-color var(--transition-normal, 250ms), box-shadow var(--transition-normal, 250ms)',
  };
  
  // 移动端使用 Drawer
  if (isMobile) {
    return (
      <Drawer
        placement="left"
        open={drawerVisible}
        onClose={closeDrawer}
        width={SIDEBAR_WIDTH}
        styles={{ 
          body: { 
            padding: 0, 
            height: '100%',
            overflow: 'hidden',
          } 
        }}
        closable={false}
      >
        <SidebarContent isDark={isDark} />
      </Drawer>
    );
  }
  
  // 桌面端使用固定侧边栏
  return (
    <Sider
      width={SIDEBAR_WIDTH}
      collapsedWidth={SIDEBAR_COLLAPSED_WIDTH}
      collapsed={collapsed}
      style={siderBaseStyle}
      trigger={null}
    >
      <SidebarContent isDark={isDark} />
    </Sider>
  );
};

export default Sidebar;
